/**
* 导航栏
*/ 
<template>
  <div>
    <div class="top-title">
      <div>
        你好，{{adminName}}
        <el-badge v-if="noticeCount>0" :value="noticeCount" style="margin-left: 8px;cursor: pointer;" title="查看未读消息">
          <i class="el-icon-bell" @click="viewMsg"></i>
        </el-badge>
      </div>
      
      <div style="margin-left: auto;margin-right: 0px;cursor: pointer;" title="退出" @click="layout">
        <i class="el-icon-switch-button"></i>
        <!-- <div class="toplayout-icon"><img :src="layoutIncon"></div> -->
      </div>
    </div>
    <div class="top-date">今天是{{today}}，{{week}}</div>
    <div>
    <div class="buttonimg">
      <img v-if="collapsed" class="showimg" :src="collapsed?imgshow:imgsq" @click="toggle(collapsed)" title="折叠">
      <img v-else class="hiddenimg" :src="collapsed?imgshow:imgsq" @click="toggle(collapsed)" title="展开">
    </div>
    </div>
  </div>
</template>
<script>
  import { getUnreadAdviceNum } from '../api/crmMG'
  export default {
    name: 'navtop',
    data() {
      return {
        collapsed: true,
        imgshow: require('../assets/img/top-show.png'),
        imgsq: require('../assets/img/top-hidden.png'),
        layoutIncon: require('../assets/img/layout.png'),
        today: '',
        week: '',
        adminName: '',
        noticeCount: 0,
      }
    },
    created() {
      this.getCurrentDate();
      this.getAdminName();
      this.getAdminMsgNum()
    },

    mounted() {
      window.addEventListener('setItem', this.updateUnreadMsgCount);
      // window.addEventListener('setItem', (e) => {
      //   if(e.key === 'noticeCount'){
      //     this.updateUnreadMsgCount()
      //   }
      // });

    },
    beforeDestroy() {
      window.removeEventListener('setItem', this.updateUnreadMsgCount);
    },
    methods: {
      // 切换显示
      toggle(showtype) {
        if(showtype){
        this.$root.Bus.$emit('toggle', !showtype)
         setTimeout(() => {
          this.collapsed = !showtype
         },300)
        }else{
          this.$root.Bus.$emit('toggle', !showtype)
          this.collapsed = !showtype
        }
      },
      layout(){
        this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('userdata');
            window.localStorage.removeItem('logintoken');
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      // 获取当前日期
      getCurrentDate() {
        let now = new Date();
        let year = now.getFullYear();
        let month = now.getMonth() + 1;
        let day = now.getDate();
        let days = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
        let week = now.getDay();
        this.today = year + '年' + month + '月' + day + '日';
        this.week = days[week];
      },
      // 获取当前账户名称
      getAdminName() {
        let user = localStorage.getItem('userdata')
        let userInfo = JSON.parse(user)
        this.adminName = userInfo.real_name
      },
      // 查询账户未读消息数量
      getAdminMsgNum() {
        let param = {}
        getUnreadAdviceNum(param)
        .then(res=>{
          if(res.code == 200){
            this.noticeCount = res.data.num
             sessionStorage.setItem('noticeCount',res.data.num)
          }
        })
      },
      // 查看未读消息
      viewMsg() {
        this.$router.push({path: '/crm/advice'})
      },
      updateUnreadMsgCount() {
        console.log('进入啦！！！！')
        this.noticeCount = sessionStorage.getItem('noticeCount');
      },
    } 
  }
</script>
<style>
.top-title {
  font-weight: 700;
  font-size: 24px;
  height: 40px;
  line-height: 40px;
  display: flex;;
}
.top-date {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}
.buttonimg {
  height: 60px;
  /* background-color: transparent; */
  border: none;
  cursor: pointer;
}
.showimg {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 150px;
  left: 218px;
  z-index: 10;
}
.hiddenimg {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 150px;
  left: 100px;
  z-index: 10;
}
.showimg:active {
  border: none;
}
.toplayout-icon img {
  width: 32px;
  height: 32px;
  margin-top: 4px;
}
</style>




// WEBPACK FOOTER //
// src/components/navtop.vue